declare namespace $ {

	type $jin_keyboard__area_jin_keyboard_demo_1 = $mol_type_enforce<
		ReturnType< $jin_keyboard_demo['Area'] >
		,
		ReturnType< $jin_keyboard['area'] >
	>
	type $mol_list__rows_jin_keyboard_demo_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $jin_keyboard_demo extends $mol_example_small {
		Area( ): $mol_string
		keyboard( ): $jin_keyboard
		Content( ): $mol_list
		title( ): string
		sub( ): readonly(any)[]
		tags( ): readonly(any)[]
		aspects( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=demo.view.tree.d.ts.map